import React from 'react';
import { Route } from 'react-router-dom';
import EmbeddedChat from '@/pages/EmbeddedChat';
import UnifiedChatPage from '@/pages/UnifiedChatPage';

/**
 * Routes for the embedded chat, used for both:
 * 1. Preview iframe in the builder
 * 2. Production embedding via script
 *
 * This ensures a true 1:1 preview-to-production experience
 */
export const embeddedRoutes = (
  <>
    {/* The /chat/:chatbotId route is used for both preview and production */}
    <Route path="/chat/:chatbotId" element={<UnifiedChatPage />} />

    {/* Legacy route support */}
    <Route path="/embed/:chatbotId" element={<UnifiedChatPage />} />

    {/* Keep old component for backward compatibility */}
    <Route path="/legacy-embed/:chatbotId" element={<EmbeddedChat />} />
  </>
);
